import { kuwaitForecastSchema } from "@/schemas/kuwait-forecast-schema";
import { IKuwaitForecast } from "@/types/kuwait-forecast-type";

export const fetchForecastKuwait = async (
	date: Date,
): Promise<IKuwaitForecast> => {
	const years = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");

	try {
		const res = await fetch(
			`https://kuwait.exelys.io/kuwait_forecast_text/kuwait_forecast_text_${years}-${month}-${day}.json`,
		);

		if (!res.ok) {
			throw new Error("Une erreur est suvenue");
		}

		const data = await res.json();

		const validatedData = kuwaitForecastSchema.parse(data);

		return {
			isLoading: false,
			error: null,
			forecastData: validatedData,
		};
	} catch {
		return {
			isLoading: false,
			error: "Une erreur est survenue",
			forecastData: null,
		};
	}
};
